// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

var state = {
  logs: []
};
var mutations = {
  ADD_ERROR_LOG: function ADD_ERROR_LOG(state, log) {
    state.logs.push(log);
  },
  CLEAR_ERROR_LOG: function CLEAR_ERROR_LOG(state) {
    state.logs.splice(0);
  }
};
var actions = {
  addErrorLog: function addErrorLog(_ref, log) {
    var commit = _ref.commit;
    commit('ADD_ERROR_LOG', log);
  },
  clearErrorLog: function clearErrorLog(_ref2) {
    var commit = _ref2.commit;
    commit('CLEAR_ERROR_LOG');
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};